



















import { Component, Vue, namespace, Watch } from 'nuxt-property-decorator'
import { VIDEO_API } from '~/assets/config/api-path'
import { IStyle } from '~/assets/interfaces/classes'
import { NuxtAppOptions } from '~/node_modules/@nuxt/types'
import { VIDEO_PATH } from '~/assets/config/path'
import { IBreadcrumbsItem } from '~/assets/interfaces/navigation'
import { IMeta } from '~/assets/interfaces/meta'
import ComponentNavigationPagination from '~/components/navigation/pagination.vue'
import ComponentPageContent from '~/components/pages/content.vue'
import ComponentIntersect from '~/components/intersect/intersect.vue'
import ComponentVideoItem from '~/components/video/video-item.vue'
import ComponentTypographyH1 from '~/components/typography/h1.vue'

const pageStore = namespace('page')
@Component({
  watchQuery: ['page'],
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    ComponentPageContent,
    ComponentIntersect,
    ComponentVideoItem,
    ComponentTypographyH1,
    ComponentNavigationPagination,
  },
})
export default class pageVideo extends Vue {
  private async asyncData({
    $axios,
    route,
  }: {
    $axios: NuxtAppOptions
    route: NuxtAppOptions
  }) {
    const response = await $axios.$get(VIDEO_API, {
      params: {
        page: route.query.page || '1',
      },
    })

    return response
  }

  private breadcrumbs: IBreadcrumbsItem[] = [
    {
      title: 'Видео',
      url: VIDEO_PATH,
    },
  ]

  private styleSpacer!: IStyle
  private $style!: IStyle
  private pages = 1

  private get classList() {
    return {
      [this.$style.list]: true,
      [this.styleSpacer.mb24]: true,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
    }
  }

  @pageStore.Mutation('setMeta') private setMeta!: (
    meta: IMeta
  ) => Promise<void>

  private meta: IMeta | null = null

  @Watch('meta', { immediate: true })
  private metaHandler(val: IMeta) {
    if (val) {
      this.setMeta(val)
    }
  }
}
